export default class Medicine {
  static all () {
    return {'medicines': [{'pdf': '201701251428_06021702_TANAKA.PDF', 'date': '平成27年2月1日'}, {'pdf': '201701251428_06021702_TANAKA.PDF', 'date': '平成27年2月1日'}, {'pdf': '201701251428_06021702_TANAKA.PDF', 'date': '平成27年2月1日'}]}
  }

  static allPdf () {
    return {'pdf': [{'patient_name': '鈴木一郎', 'date': '平成27年2月1日', 'file_name': '201701251428_06021702_TANAKA.PDF', 'update_count': 2}, {'patient_name': '鈴木一郎', 'date': '平成27年2月1日', 'file_name': '201701251428_06021702_TANAKA.PDF', 'update_count': 1}, {'patient_name': '鈴木一郎', 'date': '平成27年2月1日', 'file_name': '201701251428_06021702_TANAKA.PDF', 'update_count': 1}]}
  }
}



// WEBPACK FOOTER //
// ./src/components/model/medicine.js